import { render, staticRenderFns } from "./Productivity.vue?vue&type=template&id=c5425008&"
import script from "./Productivity.vue?vue&type=script&lang=js&"
export * from "./Productivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports